import { getJsonInternal } from './getJsonInternal';

export function getJson<T = unknown>(url: string): Promise<T> {
  return new Promise((resolve, reject) => {
    getJsonInternal(url, resolve, reject, 5 /* retriesRemaining */);
  });
}
